import React from 'react';

type ResponsiveContextType = {
  isSm: boolean;
  isMd: boolean;
  isLg: boolean;
};

const ResponsiveContext = React.createContext<ResponsiveContextType>({
  isSm: false,
  isMd: false,
  isLg: true,
});

export default ResponsiveContext;
